"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  heading1: {
    element: 'h1',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '44px',
    fontWeight: '500',
    lineHeight: '52px'
  },
  heading2: {
    element: 'h2',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '40px',
    fontWeight: '500',
    lineHeight: '48px'
  },
  heading3: {
    element: 'h3',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '36px',
    fontWeight: '500',
    lineHeight: '44px'
  },
  heading4: {
    element: 'h4',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '32px',
    fontWeight: '500',
    lineHeight: '36px'
  },
  heading5: {
    element: 'h5',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '28px',
    fontWeight: '500',
    lineHeight: '32px'
  },
  heading6: {
    element: 'h6',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '24px',
    fontWeight: '500',
    lineHeight: '28px'
  },
  displayHeading1: {
    element: 'h1',
    fontFamily: '"Bower Bold"',
    fontSize: '64px',
    fontWeight: '700',
    lineHeight: '76px'
  },
  displayHeading2: {
    element: 'h2',
    fontFamily: '"Bower Bold"',
    fontSize: '60px',
    fontWeight: '700',
    lineHeight: '72px'
  },
  displayHeading3: {
    element: 'h3',
    fontFamily: '"Bower Bold"',
    fontSize: '56px',
    fontWeight: '700',
    lineHeight: '68px'
  },
  displayHeading4: {
    element: 'h4',
    fontFamily: '"Bower Bold"',
    fontSize: '52px',
    fontWeight: '700',
    lineHeight: '64px'
  },
  displayHeading5: {
    element: 'h5',
    fontFamily: '"Bower Bold"',
    fontSize: '48px',
    fontWeight: '700',
    lineHeight: '58px'
  },
  displayHeading6: {
    element: 'h6',
    fontFamily: '"Bower Bold"',
    fontSize: '44px',
    fontWeight: '700',
    lineHeight: '52px'
  },
  textSmall: {
    element: 'p',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px'
  },
  textDefault: {
    element: 'p',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px'
  },
  textLarge: {
    element: 'p',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '18px',
    fontWeight: '300',
    lineHeight: '28px'
  },
  textBody: {
    element: 'p',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '20px',
    fontWeight: '300',
    lineHeight: '32px'
  },
  textLead: {
    element: 'p',
    fontFamily: '"McKinseySans", "Verdana", sans-serif',
    fontSize: '24px',
    fontWeight: '300',
    lineHeight: '36px'
  }
};